import script from "./CaseStatementDocumentView.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseStatementDocumentView.vue?vue&type=script&setup=true&lang=js"

import "./CaseStatementDocumentView.vue?vue&type=style&index=0&id=3a5fd21d&lang=css"
import "./CaseStatementDocumentView.vue?vue&type=style&index=1&id=3a5fd21d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a5fd21d"]])

export default __exports__